import Joi from 'joi';

import { objectId } from '@/shared/validations/custom.validation';

export const getEmail = {
  query: Joi.object().keys({
    name: Joi.string(),
    email: Joi.string(),
    sortBy: Joi.string(),
    search: Joi.string(),
    limit: Joi.number().integer().min(1),
    page: Joi.number().integer().min(-1),
    companyId: Joi.string(),
    includeTimeStamps: Joi.boolean(),
    project: Joi.string(),
    status: Joi.string(),
  }),
};

export const updateTemplate = {
  params: Joi.object().keys({
    templateId: Joi.string().custom(objectId),
  }),
};
